<p-dialog
    #questionnairePopup
    [closable]="false"
    [(visible)]="displayQuestions"
    [modal]="true"
    [style]="{width: '55%', minWidth: '55%'}">
    <p-header>
        <h5 class="p-d-inline-block p-mb-0">
          Questionnaire
        </h5>
    </p-header>
    <p-tabView [(activeIndex)]="activeIndex" class="no-padding">
        <p-tabPanel header="Questions ({{questionLists.length}})">
            <form #questionnaireForm="ngForm" (ngSubmit)="submitQuestionnaire()" >
                <div class="card">
                  <div class="p-field p-formgrid p-grid"
                    *ngFor="let currentQuestion of questionLists; index as i">
                    <ng-container
                      [ngTemplateOutlet]="questionTemplate"
                      [ngTemplateOutletContext]="{ $implicit: currentQuestion, idx: i }"
                    ></ng-container>
                  </div>

                  <ng-template #questionTemplate let-currentQuestion let-i="idx" let-pi="pix">
                    <!-- dropdown list -->
                    <div id="dropDown"
                      *ngIf="currentQuestion.question.formControlId == '1' && (currentQuestion.question.questionPreDefinedAnswerId == 0 || (currentQuestion.question.questionPreDefinedAnswerId != 0 && parentAnswerSelected(currentQuestion.question.questionPreDefinedAnswerId)))"
                      class="p-field p-col-12">
                      <div class="p-field">
                          <label><b>
                            <span *ngIf="pi; else parentQuestionOnly">{{pi}}.1)</span>
                            <ng-template #parentQuestionOnly> {{i+1}})</ng-template>
                            {{currentQuestion.question.name}}
                          </b></label>
                          <p-dropdown
                            name="{{currentQuestion.questionId}}"
                            placeholder="Select one"
                            [options]="currentQuestion.question.questionPreDefinedAnswers"
                            [(ngModel)]="currentQuestion.question.answerValue"
                            (onChange)="selectChildQuestion($event, currentQuestion.question.questionPreDefinedAnswers)"
                            optionLabel="preDefinedAnswerValue">
                          </p-dropdown>
                      </div>
                    </div>

                    <!-- checkbox list -->
                    <div id="checkBox"
                      *ngIf="currentQuestion.question.formControlId == '2' && (currentQuestion.question.questionPreDefinedAnswerId == 0 || (currentQuestion.question.questionPreDefinedAnswerId != 0 && parentAnswerSelected(currentQuestion.question.questionPreDefinedAnswerId)))"
                      class="p-field p-col-12">
                      <div class="p-field">
                        <label><b>
                          <span *ngIf="pi; else parentQuestionOnly">{{pi}}.1)</span>
                          <ng-template #parentQuestionOnly> {{i+1}})</ng-template>
                          {{currentQuestion.question.name}}
                        </b></label>
                        <div *ngFor="let questionPreDefinedAnswersList of currentQuestion.question.questionPreDefinedAnswers" class="p-field-checkbox p-mb-0">
                          <p-checkbox
                            name="{{currentQuestion.questionId}}"
                            binary="true"
                            [value]="questionPreDefinedAnswersList"
                            [(ngModel)]="questionPreDefinedAnswersList.isChecked"
                            [inputId]="questionPreDefinedAnswersList.preDefinedAnswerValue"
                            (onChange)="checkChildQuestion($event, currentQuestion.question.questionPreDefinedAnswers)"></p-checkbox>
                          <label [for]="questionPreDefinedAnswersList.preDefinedAnswerValue">{{questionPreDefinedAnswersList.preDefinedAnswerValue}}</label>
                        </div>
                      </div>
                    </div>

                    <!-- Radio list -->
                    <div id="radioButton"
                      *ngIf="currentQuestion.question.formControlId == '3' && (currentQuestion.question.questionPreDefinedAnswerId == 0 || (currentQuestion.question.questionPreDefinedAnswerId != 0 && parentAnswerSelected(currentQuestion.question.questionPreDefinedAnswerId)))"
                      class="p-field p-col-12">
                      <div class="p-field">
                        <label><b>
                          <span *ngIf="pi; else parentQuestionOnly">{{pi}}.1)</span>
                          <ng-template #parentQuestionOnly> {{i+1}})</ng-template>
                          {{currentQuestion.question.name}}
                        </b></label>
                        <div *ngFor="let questionPreDefinedAnswersList of currentQuestion.question.questionPreDefinedAnswers" class="p-field-checkbox p-mb-0">
                          <p-radioButton
                            name="{{currentQuestion.questionId}}"
                            binary="true"
                            [value]="questionPreDefinedAnswersList.preDefinedAnswerValue"
                            [(ngModel)]="currentQuestion.answerSelected"
                            [inputId]="questionPreDefinedAnswersList.preDefinedAnswerValue"
                            (onClick)="radioButtonSelected(questionPreDefinedAnswersList, currentQuestion.question.questionPreDefinedAnswers)">
                          </p-radioButton>
                          <label style="margin-top: 15px;" [for]="questionPreDefinedAnswersList.preDefinedAnswerValue">{{questionPreDefinedAnswersList.preDefinedAnswerValue}}</label>
                        </div>
                      </div>
                    </div>

                    <!-- Toggle Button -->
                    <div id="radioButton"
                      *ngIf="currentQuestion.question.formControlId == '4' && (currentQuestion.question.questionPreDefinedAnswerId == 0 || (currentQuestion.question.questionPreDefinedAnswerId != 0 && parentAnswerSelected(currentQuestion.question.questionPreDefinedAnswerId)))"
                      class="p-field p-col-12">
                      <div class="p-field">
                        <label><b>
                          <span *ngIf="pi; else parentQuestionOnly">{{pi}}.1)</span>
                          <ng-template #parentQuestionOnly> {{i+1}})</ng-template>
                          {{currentQuestion.question.name}}
                        </b></label>
                        <div *ngIf="currentQuestion.question.questionPreDefinedAnswers?.length>0">
                          <p-toggleButton
                            name="{{currentQuestion.questionId}}"
                            onLabel="{{currentQuestion.question.questionPreDefinedAnswers[0].preDefinedAnswerValue}}"
                            offLabel="{{currentQuestion.question.questionPreDefinedAnswers[1].preDefinedAnswerValue}}"
                            [(ngModel)]="currentQuestion.selectedValue">
                          </p-toggleButton>
                        </div>
                      </div>
                    </div>

                     <!-- Image Selection -->
                     <div id="image" *ngIf="currentQuestion.question.formControlId == '5' && (currentQuestion.question.questionPreDefinedAnswerId == 0 || (currentQuestion.question.questionPreDefinedAnswerId != 0 && parentAnswerSelected(currentQuestion.question.questionPreDefinedAnswerId)))"
                         class="p-col-12">
                       <!-- <label>Select Image</label> -->
                       <div>
                        <label><b>
                          <span *ngIf="pi; else parentQuestionOnly">{{pi}}.1)</span>
                          <ng-template #parentQuestionOnly> {{i+1}})</ng-template>
                          {{currentQuestion.question.name}}
                        </b></label>
                         <p-fileUpload
                            name="{{currentQuestion.questionId}}"
                            customUpload="true"
                            class="fupload"
                            previewWidth="100"
                            chooseLabel="Choose"
                            [showUploadButton]="false"
                            [showCancelButton]="false"
                            accept="image/*"
                            (onSelect)="addQuestionsAttachment($event.files, currentQuestion)">
                             <ng-container *ngFor="let attachmentObj of currentQuestion.attachments; let i = index;">
                                 <ng-container *ngIf="attachmentObj.statusId === 1">
                                     <div class="p-fileupload-row">
                                         <div style="width: 100px !important;"></div>
                                         <div>{{ attachmentObj.name }}</div>
                                         <div>{{ (attachmentObj.sizeInBytes / 1024).toFixed(2) + ' KB' }}</div>
                                         <div>
                                             <button icon="pi pi-times" pButton (click)="removeAttachment(i, currentQuestion)" type="button" icon="pi pi-times"></button>
                                         </div>
                                     </div>
                                 </ng-container>
                             </ng-container>
                         </p-fileUpload>
                       </div>
                     </div>

                      <!-- File Upload -->
                     <div id="fie" *ngIf="currentQuestion.question.formControlId == '6' && (currentQuestion.question.questionPreDefinedAnswerId == 0 || (currentQuestion.question.questionPreDefinedAnswerId != 0 && parentAnswerSelected(currentQuestion.question.questionPreDefinedAnswerId)))"
                     id="addBussinessCard" class="p-col-12">
                       <!-- <label>Select Image</label> -->
                       <div >
                        <label><b>
                          <span *ngIf="pi; else parentQuestionOnly">{{pi}}.1)</span>
                          <ng-template #parentQuestionOnly> {{i+1}})</ng-template>
                          {{currentQuestion.question.name}}
                        </b></label>
                         <p-fileUpload
                            name="{{currentQuestion.questionId}}"
                            customUpload="true"
                            class="fupload"
                            previewWidth="100"
                            chooseLabel="Choose"
                            [showUploadButton]="false"
                            [showCancelButton]="false"
                            (onSelect)="addQuestionsAttachment($event.files, currentQuestion)">
                             <ng-container *ngFor="let attachment of questionsImageList; let i = index;">
                                 <ng-container *ngIf="attachment.attachment.statusId === 1">
                                     <div class="p-fileupload-row">
                                         <div style="width: 100px !important;"></div>
                                         <div>{{ attachment.attachment.name }}</div>
                                         <div>{{ (attachment.attachment.sizeInBytes / 1024).toFixed(2) + ' KB' }}</div>
                                         <div>
                                             <button icon="pi pi-times" pButton (click)="removeAttachment(i, currentQuestion)" type="button" icon="pi pi-times"></button>
                                         </div>
                                     </div>
                                 </ng-container>
                             </ng-container>
                         </p-fileUpload>
                       </div>
                     </div>

                    <!-- Rating -->
                    <!-- <p-rating [(ngModel)]="val"></p-rating> -->
                    <div id="rating"
                      *ngIf="currentQuestion.question.formControlId == '7' && (currentQuestion.question.questionPreDefinedAnswerId == 0 || (currentQuestion.question.questionPreDefinedAnswerId != 0 && parentAnswerSelected(currentQuestion.question.questionPreDefinedAnswerId)))"
                      class="p-field p-col-12">
                      <div class="p-field">
                        <label><b>
                          <span *ngIf="pi; else parentQuestionOnly">{{pi}}.1)</span>
                          <ng-template #parentQuestionOnly> {{i+1}})</ng-template>
                          {{currentQuestion.question.name}}
                        </b></label>
                        <p-rating
                          name="{{currentQuestion.questionId}}"
                          [(ngModel)]="currentQuestion.answerSelected"
                          [cancel]="false"
                          >
                        </p-rating>
                      </div>
                    </div>

                     <!-- Input box -->
                    <div id="rating"
                      *ngIf="currentQuestion.question.formControlId == 8 && (currentQuestion.question.questionPreDefinedAnswerId == 0 || (currentQuestion.question.questionPreDefinedAnswerId != 0 && parentAnswerSelected(currentQuestion.question.questionPreDefinedAnswerId)))"
                      class="p-field p-col-12">
                      <div class="p-field">
                        <label><b>
                          <span *ngIf="pi; else parentQuestionOnly">{{pi}}.1)</span>
                          <ng-template #parentQuestionOnly> {{i+1}})</ng-template>
                          {{currentQuestion.question.name}}
                        </b></label>
                        <input
                          pInputText
                          type="text"
                          name="{{currentQuestion.questionId}}"
                          [(ngModel)]="currentQuestion.answerSelected"
                          [cancel]="false"
                          />
                      </div>
                    </div>

                    <div
                      id="comments"
                      class="p-field p-col-12"
                      *ngIf="(currentQuestion.question.questionPreDefinedAnswerId == 0 || (currentQuestion.question.questionPreDefinedAnswerId != 0 && parentAnswerSelected(currentQuestion.question.questionPreDefinedAnswerId)))"  >
                      <label for="comment">Comment</label>
                      <textarea
                        [(ngModel)]="currentQuestion.comment"
                        type="text"
                        rows="4"
                        [ngModelOptions]="{standalone: true}"
                        placeholder="Enter comment"
                        pInputTextarea>
                      </textarea>
                    </div>

                    <!-- iterrate for subquestions -->
                    <ng-container *ngIf="currentQuestion.question.subQuestions && currentQuestion.question.subQuestions.length">
                      <div  class="p-field p-col-12"
                        *ngFor="let subQuestion of currentQuestion.question.subQuestions; index as ci">
                        <ng-container
                          [ngTemplateOutlet]="questionTemplate"
                          [ngTemplateOutletContext]="{ $implicit: subQuestion, idx: ci, pix: i+1 }"
                        ></ng-container>
                      </div>
                    </ng-container>

                  </ng-template>
                  <div *ngIf="questionLists.length == 0">
                    <p>No questions added.</p>
                  </div>
                </div>
            </form>
        </p-tabPanel>
        <p-tabPanel header="External Links ({{externalLinks.length}})">
            <div *ngIf="externalLinks.length > 0" class="p-field p-col-12">
                <ng-container *ngFor="let addedQuestionnaire of questionnairsData; let i = index;">
                    <ng-container *ngIf="addedQuestionnaire?.selected && addedQuestionnaire.surveyExternalLinks?.length > 0">
                        <div class="p-field p-col-12">
                            <h5 class="p-m-0">Questionnaire: {{addedQuestionnaire.name}}</h5>
                            <div class="p-col-12 p-mb-0 p-pb-0" *ngFor="let externalLink of addedQuestionnaire.surveyExternalLinks; let j = index;">
                                <div class="p-d-flex p-ai-center p-jc-between p-mb-2 external-link-container">
                                    <div class="external-link-title p-d-flex p-ai-center">
                                        <i class="pi pi-link p-mr-2"></i>
                                        <span class="link-text">
                                            {{externalLink.details}}<br>
                                            <a [href]="externalLink.link" target="_blank" class="truncate-text">{{externalLink.link}}</a>
                                        </span>
                                    </div>
                                    <div class="external-link-actions">
                                        <button pButton
                                            type="button"
                                            icon="pi pi-copy"
                                            class="p-button-rounded p-button-text p-mr-2"
                                            pTooltip="Copy link to clipboard"
                                            tooltipPosition="top"
                                            (click)="copyLinkToClipboard(externalLink.link)">
                                        </button>
                                        <button pButton
                                            type="button"
                                            icon="pi pi-external-link"
                                            class="p-button-rounded p-button-text"
                                            pTooltip="Open in new tab"
                                            tooltipPosition="top"
                                            (click)="openLinkInNewTab(externalLink.link)">
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </ng-container>
            </div>
            <div *ngIf="externalLinks.length == 0" class="p-field p-col-12">
                <p>No external links added.</p>
            </div>
        </p-tabPanel>
    </p-tabView>


    <ng-template pTemplate="footer">
      <button  pButton label="Cancel" (click)=" cancelSubmit()"  class="p-button-secondary"></button>
      <button  pButton label="Checkout" (click)="questionnaireForm.ngSubmit.emit()"></button>
  </ng-template>
</p-dialog>

<p-dialog  header="Select Questionnaire" [modal]="true" [(visible)]="chooseChannelPopup" (onHide)="chooseChannelPopup=false" [closable]="true" [responsive]="true" styleClass="checkin-popup"  [style]="{width: '35vw'}">

    <ng-template pTemplate="content">
        <div class="p-grid p-p-3 p-pt-0">
            <div class="card p-col-12">

                <!-- checkbox list -->
                <div *ngIf="questionnairsData?.length>0" id="checkBox" class="p-field p-col-12">
                    <div *ngFor="let quiestionnaire of (questionnairsData||[])" class="p-field-checkbox p-mb-2">
                        <p-checkbox
                            name="choose_channel"
                            binary="true"
                            [value]="quiestionnaire"
                            [(ngModel)]="quiestionnaire['selected']"
                            [disabled]="!(quiestionnaire?.questions?.length>0 || quiestionnaire?.surveyExternalLinks?.length>0)"
                            [inputId]="'choose_channel'+quiestionnaire.id">
                        </p-checkbox>
                        <label style="margin-top: 5px;" [for]="'choose_channel'+quiestionnaire.id">{{ quiestionnaire.name }}
                            <small>
                                ({{ quiestionnaire?.questions?.length }}
                                {{ quiestionnaire?.questions?.length === 1 ? 'Question' : 'Questions' }},
                                {{ quiestionnaire?.surveyExternalLinks?.length }}
                                {{ quiestionnaire?.surveyExternalLinks?.length === 1 ? 'External Link' : 'External Links' }})
                            </small>
                        </label>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>

    <p-footer>
        <div style="text-align: right;">
            <p-button label="Continue" (click)="setQuestionnaireQuestions()"></p-button>
        </div>
    </p-footer>
</p-dialog>
